var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-layout"},[_c('div',{staticClass:"legal-layout__inner"},[_c('h1',{staticClass:"legal-layout__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"legal-layout__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }